import Collapse from './Collapse';
import CollapseItem from './CollapseItem';

Collapse.Item = CollapseItem;

export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/collapse/index.js
// module id = 353
// module chunks = 0